<template>
<div class="container">
    <div class="topbar">
      <div class="leftTitle">
        <h3>各门岗数据统计</h3>
      </div>
      <div class="button-group">
        <a-range-picker
          class="range-picker lianedate"
          @change="changeDate"
          :value="chooseDate"
          :disabledDate="disabledDate"
        >
          <template slot="renderExtraFooter"></template>
        </a-range-picker>
        <a-button-group>
          <a-button :type="buttonTypeOne" @click="ChooseDateButtonOne()">一周</a-button>
          <a-button :type="buttonTypeTwo" @click="ChooseDateButtonTwo()">十五天</a-button>
          <a-button :type="buttonTypeThree" @click="ChooseDateButtonThree()">一个月</a-button>
        </a-button-group>
      </div>
    </div>
    <v-chart :forceFit="true" :height="height" :data="data" :scale="scale" :onClick="handleClick">
      <v-tooltip :showTitle="false" dataKey="item*percent"/>
      <v-axis/>
      <v-legend dataKey="item"/>
      <v-pie position="quantity" color="item" :v-style="pieStyle" :label="labelConfig"/>
      <v-coord type="theta"/>
    </v-chart>
  </div>  
</template>

<script>
  const DataSet = require('@antv/data-set')
  import { getVisitorPlacePieData} from '@/api/api'
  import moment from 'moment'
  import { ChartEventMixins } from './mixins/ChartMixins'

  export default {
    name: 'Pie',
    mixins: [ChartEventMixins],
    props: {
      title: {
        type: String,
        default: ''
      },
      height: {
        type: Number,
        default: 360
      },
      // dataSource: {
      //   type: Array,
      //   default: () => [
      //     { item: '示例一', count: 40 },
      //     { item: '示例二', count: 21 },
      //     { item: '示例三', count: 17 },
      //     { item: '示例四', count: 13 },
      //     { item: '示例五', count: 9 }
      //   ]
      // }
    },
    data() {
      return {
        scale: [{
          dataKey: 'percent',
          min: 0,
          formatter: '.0%'
        }],
        pieStyle: {
          stroke: '#fff',
          lineWidth: 1
        },
        labelConfig: ['percent', {
          formatter: (val, item) => {
            return item.point.item + ': ' + val
          }
        }],
        
      buttonTypeOne: '',
      buttonTypeTwo: '',
      buttonTypeThree: '',
      chooseDate: [
        moment(moment(new Date()).subtract(6, 'day').format('YYYY-MM-DD'), 'YYYY-MM-DD'),
        moment(moment(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD'),
      ],
      parmsDate: [],
      padding: [20, 'auto'],
      loadingTemplate: false,
      loadingSource: false,
      dataSource: [
        { item: '暂无数据', percent: 100, quantity: 100 },
      ]
      }
    },
    mounted() {
      this.ChooseDateButtonOne()
    },
    methods: {
      disabledDate(current) {
        return current > moment(moment(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD')
      },
      ChooseDateButtonOne() {
        this.buttonTypeOne = 'primary'
        this.buttonTypeTwo = ''
        this.buttonTypeThree = ''
        this.parmsDate[0] = moment(new Date()).subtract(6, 'day').format('YYYY-MM-DD')
        this.parmsDate[1] = moment(new Date()).format('YYYY-MM-DD')
        this.chooseDate[0] = moment(moment(new Date()).subtract(6, 'day').format('YYYY-MM-DD'), 'YYYY-MM-DD')
        this.chooseDate[1] = moment(moment(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD')
        // this.getTemplateDate()
        this.getSourceDate()
      },
      ChooseDateButtonTwo() {
        this.buttonTypeOne = ''
        this.buttonTypeTwo = 'primary'
        this.buttonTypeThree = ''
        this.parmsDate[0] = moment(new Date()).subtract(14, 'day').format('YYYY-MM-DD')
        this.parmsDate[1] = moment(new Date()).format('YYYY-MM-DD')
        this.chooseDate[0] = moment(moment(new Date()).subtract(14, 'day').format('YYYY-MM-DD'), 'YYYY-MM-DD')
        this.chooseDate[1] = moment(moment(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD')
        // this.getTemplateDate()
        this.getSourceDate()
      },
      ChooseDateButtonThree() {
        this.buttonTypeOne = ''
        this.buttonTypeTwo = ''
        this.buttonTypeThree = 'primary'
        this.parmsDate[0] = moment(new Date()).subtract(1, 'month').format('YYYY-MM-DD')
        this.parmsDate[1] = moment(new Date()).format('YYYY-MM-DD')
        this.chooseDate[0] = moment(moment(new Date()).subtract(1, 'month').format('YYYY-MM-DD'), 'YYYY-MM-DD')
        this.chooseDate[1] = moment(moment(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD')
        // this.getTemplateDate()
        this.getSourceDate()
      },
      changeDate(dates, dateStrings) {
        this.chooseDate = dates
        this.parmsDate[0] = dateStrings[0]
        this.parmsDate[1] = dateStrings[1]
        this.buttonTypeOne = ''
        this.buttonTypeTwo = ''
        this.buttonTypeThree = ''
        // this.getTemplateDate()
        this.getSourceDate()
      },
      getTemplateDate() {
        this.loadingTemplate = true
        let params = {
          endTime: this.parmsDate[1],
          startTime: this.parmsDate[0],
        }
        templateTop5Count(params).then((res) => {
          if (res.success) {
            this.data = res.result
            this.loadingTemplate = false
          } else {
            // this.ChooseDateButtonOne()
          }
        })
      },
      getSourceDate() {
        this.loadingSource = true
        let params = {
          endTime: this.parmsDate[1],
          startTime: this.parmsDate[0],
        }
        getVisitorPlacePieData(params).then((res) => {
          if (res.success) {
            if(res.result.length > 0) {
              console.log(res)
              this.dataSource = res.result
            }else{
              this.dataSource = [{ item: '暂无数据', percent: 100, quantity: 0.001 }]
            }
          }
        })
      },
    },
    computed: {
      data() {
        let dv = new DataSet.View().source(this.dataSource)
        // 计算数据百分比
        dv.transform({
          type: 'percent',
          field: 'percent',
          dimension: 'item',
          as: 'percent'
        })
        return dv.rows
      }
    }
  }
</script>
</script>

<style scoped>
.container {
  padding-top: 10px;
  margin-left: 1%;
  width: 100%;
}
.leftchart {
  width: 45%;
  height: 100%;
  margin-right: 5%;
  display: inline-block;
}
.rightchart {
  width: 45%;
  height: 100%;
  display: inline-block;
}

.topbar {
  height: 100%;
  width: 98%;
}

.leftTitle {
  height: 100%;
  width: 49%;
  margin-top: 1%;
  margin-left: 1%;
  display: inline-block;
}
.chart {
  height: 100%;
  width: 99%;
  margin-top: 2%;
  background-color: #ffffff;
  margin-left: 1.5%;
}
.button-group {
  height: 100%;
  width: 49%;
  display: inline-block;
  text-align: right;
}
.range-picker {
  width: 35%;
  margin-right: 3%;
}
</style>